import React, { useRef } from 'react';
import { Tooltip } from 'antd';
import { useDarkMode } from './useDarkMode';
import './DarkModeToggle.css';

let maskSeq = 0;

const ThemeOrb = ({ maskId }) => (
  <svg className="dark-mode-toggle__svg" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
    <mask id={maskId}>
      <rect x="-6" y="-6" width="36" height="36" fill="#fff" />
      <circle className="dark-mode-toggle__bite" cx="15.5" cy="8.5" r="9.5" fill="#000" />
    </mask>
    <circle
      className="dark-mode-toggle__orb"
      cx="12"
      cy="12"
      r="9"
      fill="currentColor"
      mask={`url(#${maskId})`}
    />
    <g className="dark-mode-toggle__rays" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
      <line x1="12" y1="1.4" x2="12" y2="3.3" />
      <line x1="12" y1="20.7" x2="12" y2="22.6" />
      <line x1="1.4" y1="12" x2="3.3" y2="12" />
      <line x1="20.7" y1="12" x2="22.6" y2="12" />
      <line x1="4.3" y1="4.3" x2="5.7" y2="5.7" />
      <line x1="18.3" y1="18.3" x2="19.7" y2="19.7" />
      <line x1="4.3" y1="19.7" x2="5.7" y2="18.3" />
      <line x1="18.3" y1="5.7" x2="19.7" y2="4.3" />
    </g>
  </svg>
);

const DarkModeToggle = ({ className = '', iconSize = 22, scale }) => {
  const { dark, toggle } = useDarkMode();
  const maskId = useRef(null);
  if (maskId.current === null) {
    maskSeq += 1;
    maskId.current = `dark-mode-toggle-mask-${maskSeq}`;
  }
  const buttonScale = scale ?? 1;

  return (
    <Tooltip title={dark ? 'Switch to light mode' : 'Switch to dark mode'} placement="bottom">
      <button
        type="button"
        className={`dark-mode-toggle ${className}`.trim()}
        onClick={toggle}
        aria-pressed={dark}
        aria-label={dark ? 'Turn off dark mode' : 'Turn on dark mode'}
        style={buttonScale !== 1 ? { transform: `scale(${buttonScale})`, transformOrigin: 'center' } : undefined}
      >
        <span className="dark-mode-toggle__icon" style={{ width: iconSize, height: iconSize }}>
          <ThemeOrb maskId={maskId.current} />
        </span>
      </button>
    </Tooltip>
  );
};

export default DarkModeToggle;
